import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  UserCheck, 
  ClipboardList,
  Menu
} from 'lucide-react';
import { cn } from '../lib/utils';

const MobileBottomNav = ({ onMenuClick }) => {
  const location = useLocation();

  const navItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Home' },
    { path: '/fighters', icon: Users, label: 'Fighters' },
    { path: '/attendance', icon: UserCheck, label: 'Check-in' },
    { path: '/assessments', icon: ClipboardList, label: 'Assess' },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-[60] bg-ba-black/95 backdrop-blur-xl border-t border-ba-border safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || 
            (item.path !== '/dashboard' && location.pathname.startsWith(item.path));
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center flex-1 py-2 transition-colors",
                isActive ? "text-red-500" : "text-zinc-500"
              )}
            >
              <item.icon className={cn(
                "w-5 h-5 mb-1",
                isActive && "drop-shadow-[0_0_8px_rgba(220,38,38,0.5)]"
              )} />
              <span className="text-[10px] font-body tracking-wide">{item.label}</span>
            </Link>
          );
        })}
        <button
          onClick={onMenuClick}
          className="flex flex-col items-center justify-center flex-1 py-2 text-zinc-500 active:text-white transition-colors"
        >
          <Menu className="w-5 h-5 mb-1" />
          <span className="text-[10px] font-body tracking-wide">More</span>
        </button>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
